import { saveAs } from "file-saver";

export async function downloadAdviserLogo(url, name, format) {
  const response = await fetch(url);
  if (!response.ok) throw new Error("Could not load the logo. Please try again.");
  const source = await response.blob();
  const filename = `${String(name || "adviser").replace(/[^a-z0-9_-]+/gi, "-")}-logo.${format}`;
  const sourceText = await source.text();
  const isSvg = /^\s*(?:<\?xml[^>]*>\s*)?(?:<!--[\s\S]*?-->\s*)*<svg[\s>]/i.test(sourceText);
  if (format === "svg" && isSvg) {
    saveAs(new Blob([sourceText], { type: "image/svg+xml" }), filename);
    return;
  }

  const objectUrl = URL.createObjectURL(isSvg
    ? new Blob([sourceText], { type: "image/svg+xml" }) : source);
  try {
    const image = new Image();
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () => reject(new Error("This logo could not be converted. Please try another logo."));
      image.src = objectUrl;
    });
    const canvas = document.createElement("canvas");
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Your browser could not convert the logo.");
    context.drawImage(image, 0, 0);
    if (format === "svg") {
      // Preserve raster artwork inside a portable SVG; do not claim vectorisation.
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}" viewBox="0 0 ${canvas.width} ${canvas.height}"><image width="${canvas.width}" height="${canvas.height}" href="${canvas.toDataURL("image/png")}"/></svg>`;
      saveAs(new Blob([svg], { type: "image/svg+xml" }), filename);
    } else {
      const png = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!png) throw new Error("Your browser could not create the PNG. Please try again.");
      saveAs(png, filename);
    }
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
